import React from 'react'

import {
    MdLocalOffer,
    MdTv,
    MdPeople,
    MdAssignmentInd,

} from "react-icons/md";

import { CgUserList } from "react-icons/cg";
import { GoGraph, GoSettings } from "react-icons/go";
import { BsGrid3X3Gap } from "react-icons/bs";



export const structureIntegrador = [
    {
        id: 0,
        label: "Home",
        link: "#",
        icon: <MdTv/>,
    },
    {
        id: 2,
        label: "Usuarios",
        link: "/usuarios",
        icon: <MdPeople/>,
    },
    {
        id: 3,
        type: "divider"
    },
    {
        id: 6,
        label: "Clientes",
        icon: <MdAssignmentInd/>,
        link: "/clientes",
    },
    {
        id: 7,
        label: "Service-profiles",
        icon: <CgUserList />,
        link: "/serviceProfiles"
    },
    {
        id: 8,
        label: "Device-profiles",
        icon: <GoSettings/>,
        link: "/deviceProfiles"
    },
    {
        id: 9,
        label: "Applications",
        icon: <BsGrid3X3Gap/>,
        link: "/applications"
    },
    {
        id: 10,
        label: "Marcas",
        icon: <MdLocalOffer/>,
        link: "/marcas",
    }
];

